import { render } from "./RepeatFreqInterval.vue?vue&type=template&id=70b9ced2&scoped=true"
import script from "./RepeatFreqInterval.vue?vue&type=script&lang=js"
export * from "./RepeatFreqInterval.vue?vue&type=script&lang=js"

import "./RepeatFreqInterval.vue?vue&type=style&index=0&id=70b9ced2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b9ced2"]])

export default __exports__